import React from "react";
import Footer from "./Footer";
import PropTypes from "prop-types";
import DefaultButton from "../components/DefaultButton";
import styled from "styled-components";
import { Icon } from "../assets/icons";
import MqttClient, { MqttEvent, MqttAck } from "../modules/MqttClient";

const MainView = styled.div`
  width: 100%;
  height: auto;
`;

const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;
  @media screen and (max-width: 600px) {
    width: 100%;
    height: auto;
    display: block;
    margin-top: 0.5px;
    justify-content: center;
  }
`;

class MainContent extends React.Component {
  constructor(props) {
    super(props);
    this.buttons = [];
    this.buttons[0] = [];
    this.buttons[1] = [];
    for (let i = 0; i < 2; i++) {
      for (let j = 0; j < 3; j++) {
        this.buttons[i][j] = React.createRef();
      }
    }
    this.state = {
      width: window.innerWidth,
      currentRow: 0,
      currentColumn: 0,
      activeButtons: [],
      colorBg: true,
      color: true,
      icon: true,
      errorTextValue: "",
    };
  }

  _changeColor() {
    this.setState({
      colorBg: !this.state.colorBg,
      color: !this.state.color,
      icon: !this.state.icon,
    });
  }

  _findButtonInList(currentValue) {
    return currentValue.row === this.row && currentValue.col === this.col;
  }

  _keypressToKeydownTranslation(e) {
    if (e.data.type === "keypress") {
      var event = new Event("keydown");
      event.keyCode = e.data.code;
      document.dispatchEvent(event);
    }
  }

  /**
   *
   * @param {number} row
   * @param {number} col
   * @param {boolean} [activate] `true` to activate button, `false` to deactivate, leave undefined to toggle
   */
  _toggleButton = (row, col, activate) => {
    const { activeButtons } = this.state;

    let isActive = false;
    let index = 0;
    for (var i = 0; i < activeButtons.length; i++) {
      if (activeButtons[i].row === row && activeButtons[i].col === col) {
        isActive = true;
        index = i;
        break;
      }
    }

    if (isActive) {
      if (activate === false || activate === undefined) {
        activeButtons.splice(index, 1);
      }
    } else {
      if (activate === true || activate === undefined) {
        activeButtons.push({ row: row, col: col });
      }
    }

    this.setState({ activeButtons: activeButtons });
  };

  _handleKeydown = (e) => {
    const { currentRow, currentColumn } = this.state;
    const buttonsEnum = {
      LEFT: 37,
      UP: 38,
      RIGHT: 39,
      DOWN: 40,
      OK: 13,
      RETURN: 10009,
      EXIT: 10182,
    };

    let decrementColumn = () => {
      return (
        (currentColumn - 1 + this.buttons[currentRow].length) %
        this.buttons[currentRow].length
      );
    };

    let incrementColumn = () => {
      return (
        (currentColumn + 1 + this.buttons[currentRow].length) %
        this.buttons[currentRow].length
      );
    };

    let decrementRow = () => {
      return (currentRow - 1 + this.buttons.length) % this.buttons.length;
    };

    let incrementRow = () => {
      return (currentRow + 1 + this.buttons.length) % this.buttons.length;
    };

    var newRow = currentRow;
    var newColumn = currentColumn;
    if (e.keyCode == buttonsEnum.LEFT) {
      newColumn = decrementColumn();
    } else if (e.keyCode == buttonsEnum.UP) {
      newRow = decrementRow();
    } else if (e.keyCode == buttonsEnum.RIGHT) {
      newColumn = incrementColumn();
    } else if (e.keyCode == buttonsEnum.DOWN) {
      newRow = incrementRow();
    } else if (e.keyCode == buttonsEnum.OK) {
      this.buttons[currentRow][currentColumn].current.props.onClick();
      //this._onButtonClick(currentRow, currentColumn);
      return;
    } else {
      return;
    }
    //this.buttons[newRow][newColumn].current.focus();
    this.setState({ currentRow: newRow, currentColumn: newColumn });
  };

  /**
   * @param {MqttAck} ack
   */
  _onNewAck = (ack) => {
    let index = ack.EventId.split(".").pop();
    switch (index) {
      case "0":
        this._toggleButton(0, 0, true);
        break;
      case "1":
        this._toggleButton(0, 1, true);
        break;
      case "2":
        this._toggleButton(0, 2, true);
        break;
      case "3":
        this._toggleButton(1, 0, true);
        break;
      case "4":
        this._toggleButton(1, 2, true);
        this.setState({
          colorBg: !this.state.colorBg,
          color: !this.state.color,
          icon: !this.state.icon,
        });
        break;
      default:
        break;
    }
  };

  _onNewStatus = (mqttstatus) => {
    if (mqttstatus === "dead") {
      this.setState({ errorTextValue: "Connection down!" });
    } else {
      this.setState({ errorTextValue: "" });
    }
  };

  /**
   * @param {MqttEvent} event
   */
  _onNewEvent = (event) => {
    if (event.Type === "RESET") {
      let index = event.EventId.split(".").pop();
      switch (index) {
        case "0":
          this._toggleButton(0, 0, false);
          break;
        case "1":
          this._toggleButton(0, 1, false);
          break;
        case "2":
          this._toggleButton(0, 2, false);
          break;
        case "3":
          this._toggleButton(1, 0, false);
          break;
        case "4":
          this._toggleButton(1, 2, false);
          this.setState({
            colorBg: !this.state.colorBg,
            color: !this.state.color,
            icon: !this.state.icon,
          });
          break;
        default:
          break;
      }
    }
  };

  _onMouseEnter(row, col) {
    this.setState({ currentRow: row, currentColumn: col });
  }

  _onMouseLeave() {
    //this.setState({ currentRow: 0, currentColumn: 0 });
  }

  _getClassname(row, col) {
    let curRow = this.state.currentRow;
    let curCol = this.state.currentColumn;
    let isCurrent = row === curRow && col === curCol;
    let isPressed =
      this.state.activeButtons.find(this._findButtonInList, {
        row: row,
        col: col,
      }) !== undefined;
    let classNameList = [];

    if (isCurrent) {
      classNameList.push("hover");
    }

    if (isPressed) {
      classNameList.push("focus");
    }

    return classNameList.join(" ");
  }

  _handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  _sendIfNotActive(type, eventid, x, y) {
    if (
      !this.state.activeButtons.find(this._findButtonInList, {
        row: x,
        col: y,
      })
    ) {
      MqttClient.sendAlarm(type, eventid);
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this._handleWindowSizeChange);
    document.addEventListener("keydown", this._handleKeydown);
    window.addEventListener("message", this._keypressToKeydownTranslation);
    MqttClient.setOnNewAckCallback(this._onNewAck);
    MqttClient.setOnNewStatusCallback(this._onNewStatus);
    MqttClient.setOnNewEventCallback(this._onNewEvent);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._handleWindowSizeChange);
    document.removeEventListener("keydown", this._handleKeydown);
    window.removeEventListener("message", this._keypressToKeydownTranslation);
  }

  render() {
    let bgColor = this.state.colorBg ? "#B9E6E6" : "#E6373C";
    let color = this.state.color ? "#E6373C" : "#005A4B";
    let icon = this.state.icon ? (
      <Icon icon="distress" />
    ) : (
      <Icon icon="distressgreen" />
    );
    const { width } = this.state;
    const isMobile = width <= 500;
    if (isMobile) {
      return (
        <MainView>
          <ButtonGroup>
            <DefaultButton
              label="mat"
              icon="restaurant"
              ref={this.buttons[0][0]}
              className={this._getClassname(0, 0)}
              onClick={() => {
                MqttClient.sendAlarm("mat");
              }}
              onMouseEnter={() => {
                this._onMouseEnter(0, 0);
              }}
              onMouseLeave={() => {
                this._onMouseLeave();
              }}
            />
            <DefaultButton
              label="toalett"
              icon="wc"
              ref={this.buttons[0][1]}
              className={this._getClassname(0, 1)}
              onClick={() => {
                MqttClient.sendAlarm("toalett");
              }}
              onMouseEnter={() => {
                this._onMouseEnter(0, 1);
              }}
              onMouseLeave={() => {
                this._onMouseLeave();
              }}
            />
            <DefaultButton
              label="vatten"
              icon="water"
              ref={this.buttons[0][2]}
              className={this._getClassname(0, 2)}
              onClick={() => {
                MqttClient.sendAlarm("vatten");
              }}
              onMouseEnter={() => {
                this._onMouseEnter(0, 2);
              }}
              onMouseLeave={() => {
                this._onMouseLeave();
              }}
            />
          </ButtonGroup>
          <ButtonGroup>
            <DefaultButton
              label="medicin"
              icon="medicin"
              ref={this.buttons[1][0]}
              className={this._getClassname(1, 0)}
              onClick={() => {
                MqttClient.sendAlarm("medicin");
              }}
              onMouseEnter={() => {
                this._onMouseEnter(1, 0);
              }}
              onMouseLeave={() => {
                this._onMouseLeave();
              }}
            />
            <DefaultButton
              label="info"
              icon="info"
              variant="blue"
              ref={this.buttons[1][1]}
              className={this._getClassname(1, 1)}
              onClick={() => {
              }}
              onMouseEnter={() => {
                this._onMouseEnter(1, 1);
              }}
              onMouseLeave={() => {
                this._onMouseLeave();
              }}
            />
            <DefaultButton
              variant="distress"
              style={{ backgroundColor: bgColor, color: color, icon: icon }}
              ref={this.buttons[1][2]}
              className={this._getClassname(1, 2)}
              onClick={() => {
                MqttClient.sendAlarm("distress");
              }}
              onMouseEnter={() => {
                this._onMouseEnter(1, 2);
              }}
              onMouseLeave={() => {
                this._onMouseLeave();
              }}
            >
              {icon}
              <label>nödsignal</label>
            </DefaultButton>
          </ButtonGroup>
          <Footer></Footer>
        </MainView>
      );
    } else {
      return (
        <MainView>
          <div>
            <h2>{this.state.errorTextValue}</h2>
          </div>
          <ButtonGroup>
            <DefaultButton
              label="mat"
              icon="restaurant"
              ref={this.buttons[0][0]}
              className={this._getClassname(0, 0)}
              onClick={() => {
                this._sendIfNotActive("mat", "0", 0, 0);
              }}
              onMouseEnter={() => {
                this._onMouseEnter(0, 0);
              }}
              onMouseLeave={() => {
                this._onMouseLeave();
              }}
            />
            <DefaultButton
              label="toalett"
              icon="wc"
              ref={this.buttons[0][1]}
              className={this._getClassname(0, 1)}
              onClick={() => {
                this._sendIfNotActive("toalett", "1", 0, 1);
              }}
              onMouseEnter={() => {
                this._onMouseEnter(0, 1);
              }}
              onMouseLeave={() => {
                this._onMouseLeave();
              }}
            />
            <DefaultButton
              label="vatten"
              icon="water"
              ref={this.buttons[0][2]}
              className={this._getClassname(0, 2)}
              onClick={() => {
                this._sendIfNotActive("vatten", "2", 0, 2);
              }}
              onMouseEnter={() => {
                this._onMouseEnter(0, 2);
              }}
              onMouseLeave={() => {
                this._onMouseLeave();
              }}
            />
          </ButtonGroup>
          <ButtonGroup>
            <DefaultButton
              label="medicin"
              icon="medicin"
              ref={this.buttons[1][0]}
              className={this._getClassname(1, 0)}
              onClick={() => {
                this._sendIfNotActive("medicin", "3", 1, 0);
              }}
              onMouseEnter={() => {
                this._onMouseEnter(1, 0);
              }}
              onMouseLeave={() => {
                this._onMouseLeave();
              }}
            />
            <DefaultButton
              label="info"
              icon="info"
              variant="blue"
              ref={this.buttons[1][1]}
              className={this._getClassname(1, 1)}
              onClick={() => {
              }}
              onMouseEnter={() => {
                this._onMouseEnter(1, 1);
              }}
              onMouseLeave={() => {
                this._onMouseLeave();
              }}
            />
            <DefaultButton
              variant="distress"
              style={{ backgroundColor: bgColor, color: color, icon: icon }}
              ref={this.buttons[1][2]}
              className={this._getClassname(1, 2)}
              onClick={() => {
                this._sendIfNotActive("distress", "4", 1, 2);
              }}
              onMouseEnter={() => {
                this._onMouseEnter(1, 2);
              }}
              onMouseLeave={() => {
                this._onMouseLeave();
              }}
            >
              {icon}
              <label>nödsignal</label>
            </DefaultButton>
          </ButtonGroup>
          <Footer></Footer>
        </MainView>

        /* <MainView>
          <ButtonGroup>
          <ButtonRestaurant ref={this.buttons[0][0]} />
            <ButtonWc ref={this.buttons[0][1]} />
            <ButtonWater ref={this.buttons[0][2]} />
          </ButtonGroup>
          <ButtonGroup>
            <ButtonMedicin ref={this.buttons[1][0]} />
            <ButtonInfo wrappedComponentRef={this.buttons[1][1]} />
            <ButtonDistress ref={this.buttons[1][2]} />
          </ButtonGroup>
          <pre id="results">{}</pre>
          <Footer></Footer>
        </MainView>*/
      );
    }
  }
}

MainContent.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

export default MainContent;
